import { useEffect, useState } from "react";
import api from "@/lib/api";

// CYANNECT-PRICING-FINAL · every price, fee and rate on screen comes from GET /api/pricing/current.
// When the backend says final_active=false (production today) callers keep their legacy copy.
let cache = null;

export function fetchPricing() {
  if (!cache) {
    cache = api.get("/pricing/current").then((r) => r.data).catch(() => {
      cache = null;
      return null;
    });
  }
  return cache;
}

// undefined while loading, null if the request failed.
export function usePricing() {
  const [pricing, setPricing] = useState(undefined);
  useEffect(() => {
    let live = true;
    fetchPricing().then((d) => { if (live) setPricing(d); });
    return () => { live = false; };
  }, []);
  return pricing;
}

export function finalCashbackRate(pricing) {
  return pricing?.final_active ? pricing?.shopper_cashback?.standard_rate_display || null : null;
}

export function planName(pricing, id, fallback) {
  return pricing?.plans?.find((p) => p.id === id)?.name || fallback;
}

export const cadStr = (v) => `CA$${v}`;

// Shared portal money format: CA$1,234.56 (sign first), "—" when there is no value.
export const cad = (v) => {
  if (v == null || v === "" || Number.isNaN(Number(v))) return "—";
  const n = Number(v);
  return `${n < 0 ? "-" : ""}CA$${Math.abs(n).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const shortDate = (iso) => (iso && !Number.isNaN(Date.parse(iso))
  ? new Date(iso).toLocaleDateString("en-CA", { month: "short", day: "numeric", year: "numeric" }) : "—");
export const dateTime = (iso) => (iso && !Number.isNaN(Date.parse(iso))
  ? new Date(iso).toLocaleString("en-CA", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }) : "—");
